var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Modal } from '../modal';
import { bodyStaticStyle } from './styles';
function Body(_a) {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    return (_jsx(Modal.Body, Object.assign({ css: bodyStaticStyle }, restProps, { children: children })));
}
export default Body;
